module.exports = __webpack_public_path__ + "static/media/25_CALCINHA_FIO_DUPLO_LISA_02.8d230bf1.jpg";